// Import react libs
import { useState, useEffect } from 'react';

// Import services
import { preloadImages as servicePreloadImages } from '../services/images';

export function usePreloadImages(imageList) {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        let isCancelled = false;
        setIsLoading(true);

        // If the list is empty return
        if (!imageList || !Array.isArray(imageList) || !imageList.length > 0) {
            if (!isCancelled) setIsLoading(false);
            return;
        }

        async function preloadImages() {
            // Try lo preload image list
            try {
                await servicePreloadImages(imageList);
            } catch (err) {
            } finally {
                if (!isCancelled) setIsLoading(false);
            }
        }
        preloadImages();

        // Prevent actualising is loading flag if the component
        // has been unmounted
        return () => {
            isCancelled = true;
        };
    }, [imageList]);

    return { isLoading };
}
